import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface SafeTimerContextValue {
  // Define your timer state and methods here
}

const SafeTimerContext = createContext<SafeTimerContextValue | undefined>(undefined);

export function SafeTimerProvider({
  children,
  isAuthReady = false,
}: {
  children: ReactNode;
  isAuthReady?: boolean;
}) {
  const [isReady, setIsReady] = useState(!isAuthReady);

  useEffect(() => {
    if (isAuthReady && !isReady) {
      setIsReady(true);
    }
  }, [isAuthReady, isReady]);

  if (!isReady) {
    // Skip timer initialization until auth is ready
    return <>{children}</>;
  }

  return (
    <SafeTimerContext.Provider value={{ /* timer state & methods */ }}>
      {children}
    </SafeTimerContext.Provider>
  );
}

export function useSafeTimer() {
  const ctx = useContext(SafeTimerContext);
  if (!ctx) throw new Error("useSafeTimer must be used within SafeTimerProvider");
  return ctx;
}
